<template>
    <b-modal
        body-class="p-0"
        cancel-disabled
        hide-footer
        id="cancel-booking-modal"
        ok-disabled
        title="">
        <div class="modal-body modal-body-lg pt-0">
            <!-- Initial screen -->
            <empty-state
                v-if="!cancelling && !cancelled && !cancellationProcessing"
                class="pt-0"
                statusIcon="warning"
                title="Are you sure you want to cancel your appointment? <strong>You cannot undo this once cancelled.</strong>"
            >
                <slot>
                    <button class="btn btn-danger btn-lg mb-4" @click="cancelBooking()" v-if="!loading && !cancelling">Yes, cancel my booking</button>
                    <button class="btn btn-link btn-block" @click="$bvModal.hide('cancel-booking-modal')">No, I've changed my mind</button>
                </slot>
            </empty-state>

            <!-- Confirm cancellation -->
            <div class="text-center" v-if="cancelling && !cancelled && !cancellationProcessing">
                <div class="alert alert-danger" v-if="error">
                    <animated-error size="md" class="mr-2"></animated-error>
                    <div class="alert-content">
                        {{ error }}
                    </div>
                </div>
                <div class="form-group">
                    <h4 class="mb-3">Please enter CANCEL-REPAIR to cancel the appointment</h4>
                    <input type="text" class="form-control" v-model="cancelConfirm">
                </div>
                <button class="btn btn-danger btn-lg mb-4" @click="confirmCancellation">Confirm cancellation</button>
                <button class="btn btn-link btn-block" @click="cancelCancellation">I've changed my mind</button>
            </div>

            <template v-if="cancellationProcessing">
                <loading-state></loading-state>
                <h4 class="mb-4 text-center">Cancelling your booking...</h4>
            </template>

        </div>
    </b-modal>
</template>

<script>
    import {mapActions} from "vuex"

    export default {
        props:["order"],

        data() {
            return {
                cancelConfirm: null,
                cancelled: false,
                cancelling: false,
                cancellationProcessing: false,
                error: null,
                loading: false
            };
        },

        methods: {
            ...mapActions([
                "cancelOrder",
                "displayToast"
            ]),

            /** When the user selects "Yes, cancel my booking" */
            cancelBooking() {
                this.cancelling = true;
                this.error = null;
            },

            /** Cancel the cancellation */
            cancelCancellation() {
                this.cancelling = false;
                this.error = null;
            },

            /** Cancel the order */
            confirmCancellation() {
                this.cancelling = false;
                this.error = null;

                if (!this.cancelConfirm || this.cancelConfirm.toLowerCase() !== "CANCEL-REPAIR") {
                    this.error = "Please enter the text exactly as it's shown below.";
                    this.cancelling = true;
                }

                if (this.cancelConfirm.toUpperCase() === "CANCEL-REPAIR") {
                    this.cancellationProcessing = true;
                    this.cancelOrder({
                        order: this.order
                    }).then(() => {
                        this.cancellationProcessing = false;
                        this.$bvModal.hide("cancel-booking-modal")
                        this.displayToast({text: 'Your repair has been cancelled', type: 'success'});
                        this.$emit("order-cancelled");
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>